import { render, staticRenderFns } from "./ClientManagerTabs.vue?vue&type=template&id=a378b8de"
import script from "./ClientManagerTabs.vue?vue&type=script&lang=js"
export * from "./ClientManagerTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports